import { Box, Button } from "grommet";
import MediaSelectModal from "../components/roulette/settings/modal/MediaSelectModal";
import { useState } from "react";

const ButtonInput = ({ title, icon, value, onChange, category }) => {

    const [showModal, setShowModal] = useState(false);

    const handleSelect = (media) => {
        console.log(media);
        
        onChange({ target: { value: media }});
    }

    return (
        <Box>
            <Button icon={icon} label={value ? value.name : title} secondary size="small" onClick={() => setShowModal(true)} />
            {showModal && <MediaSelectModal category={category} selected={value} onClose={() => setShowModal(false)} onClick={handleSelect} />}
        </Box>
    )
}

export default ButtonInput;